import { render, staticRenderFns } from "./ListBusiness.vue?vue&type=template&id=bd8db4dc&lang=pug&"
import script from "./ListBusiness.vue?vue&type=script&lang=js&"
export * from "./ListBusiness.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports